import { render } from "./VocAddManyContent.vue?vue&type=template&id=c578b342&scoped=true"
import script from "./VocAddManyContent.vue?vue&type=script&lang=js"
export * from "./VocAddManyContent.vue?vue&type=script&lang=js"

import "./VocAddManyContent.vue?vue&type=style&index=0&id=c578b342&scoped=true&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c578b342"]])

export default __exports__